import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=8c2635ba&scoped=true&"
import script from "./NoResults.vue?vue&type=script&lang=ts&"
export * from "./NoResults.vue?vue&type=script&lang=ts&"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=8c2635ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2635ba",
  null
  
)

export default component.exports